export interface RawRefs {
  type: string;
  value: string;
  hash: string;
}
